import { FetchUtil } from "../util/FetchUtil";
import { IFindRequirementsLoadRequest } from "../models/CMERequirements/IFindRequirementsLoadRequest";
import { IFindRequirementsLoadResponse } from "../models/CMERequirements/IFindRequirementsLoadResponse";
import { IFindRequirementsServiceEndpoint } from "../models/CMERequirements/IFindRequirementsServiceEndpoint";

export class FindRequirementsService {

  constructor(private readonly _endpoint: IFindRequirementsServiceEndpoint) {
  }

  public load(req: IFindRequirementsLoadRequest, callback: object): void {
    const endpoint = this._endpoint.load;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }

    const request: IFindRequirementsLoadRequest = {
      ContextItemId: (req?.ContextItemId || "11111111-1111-1111-1111-111111111111"),
      SpecialtyIds: (req?.SpecialtyIds || []),
      StateIds: (req?.StateIds || [])
    };

    if (!request) {
      throw new Error("Missing request data.");
    }

    if (((request.SpecialtyIds?.length || 0) + (request.StateIds?.length || 0)) < 1) {
      throw new Error("At least one search parameter required.");
    }

    (async () => {
      FetchUtil.sendMessage(endpoint, request, "no-cache", false)
        .then((unknownres) => {
          const result = unknownres as IFindRequirementsLoadResponse;
          if (typeof (callback) === 'function') {
            return callback(result);
          }
        });
    })();
  }
}